module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cv"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "work-experience cv-section"
  }, [_c('h2', [_vm._v("Work Experience")]), _vm._v(" "), _vm._l((_vm.cvData.workExperience), function(work) {
    return _c('div', {
      staticClass: "container row"
    }, [_c('div', {
      staticClass: "row col-sm-1"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": work.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row col-sm-4 col-md-3"
    }, [_c('span', {
      staticClass: "col-xs-5 col-sm-12"
    }, [_c('strong', [_vm._v(_vm._s(work.company))])]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-7 col-sm-12 work-title text-right"
    }, [_c('em', [_vm._v(_vm._s(work.title))])]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-12"
    }, [_vm._v(_vm._s(_vm.monthName(work.startMonth)) + " " + _vm._s(work.startYear) + " - "), (work.endYear) ? _c('span', [_vm._v(_vm._s(_vm.monthName(work.endMonth)) + " " + _vm._s(work.endYear))]) : _c('span', [_vm._v("Present")])])]), _vm._v(" "), _c('div', {
      staticClass: "summary-line col-sm-7 col-md-8"
    }, [_c('ul', _vm._l((work.summary), function(summaryLine) {
      return _c('li', [_vm._v(_vm._s(summaryLine))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "projects"
    }, _vm._l((work.projects), function(project) {
      return _c('div', {
        staticClass: "row col-sm-12"
      }, [_c('div', {
        staticClass: "row col-sm-1"
      }, [_c('img', {
        staticClass: "logo",
        attrs: {
          "src": project.logo
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "row col-sm-4 col-md-3"
      }, [_c('span', {
        staticClass: "col-xs-5 col-sm-12"
      }, [_c('strong', [_vm._v(_vm._s(project.company))])]), _vm._v(" "), _c('span', {
        staticClass: "col-xs-7 col-sm-12 work-title text-right"
      }, [_c('em', [_vm._v(_vm._s(project.title))])]), _vm._v(" "), _c('span', {
        staticClass: "col-xs-12"
      }, [_vm._v(_vm._s(_vm.monthName(project.startMonth)) + " " + _vm._s(project.startYear) + " - "), (project.endYear) ? _c('span', [_vm._v(_vm._s(_vm.monthName(project.endMonth)) + " " + _vm._s(project.endYear))]) : _c('span', [_vm._v("Present")])])]), _vm._v(" "), _c('div', {
        staticClass: "summary-line col-sm-7 col-md-8"
      }, [_c('ul', _vm._l((project.summary), function(summaryLine) {
        return _c('li', [_vm._v(_vm._s(summaryLine))])
      }))])])
    }))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "education cv-section"
  }, [_c('h2', [_vm._v("Education")]), _vm._v(" "), _vm._l((_vm.cvData.education), function(education) {
    return _c('div', {
      staticClass: "container row"
    }, [_c('div', {
      staticClass: "row col-sm-1"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": education.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-11"
    }, [_c('strong', [(education.degree) ? _c('span', [_vm._v(_vm._s(education.degree) + " ")]) : _vm._e(), _vm._v(" "), (education.fieldOfStudy) ? _c('span', [_vm._v(_vm._s(education.fieldOfStudy) + ", ")]) : _vm._e(), _vm._v(" "), (education.school) ? _c('span') : _vm._e(), _vm._v(_vm._s(education.school) + "\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), (education.city) ? _c('span', [_vm._v(_vm._s(education.city) + ", ")]) : _vm._e(), _vm._v("\n          " + _vm._s(education.country) + " -\n          " + _vm._s(education.startYear) + "-"), (education.endYear) ? _c('span', [_vm._v(_vm._s(education.endYear))]) : _c('span', [_vm._v("Present")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "certifications-skills cv-section"
  }, [_c('h2', [_vm._v("Certifications & Skills")]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.cvData.certificationsSkills.programming), function(skill) {
    return _c('li', [_vm._v(_vm._s(skill))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.cvData.certificationsSkills.tools), function(skill) {
    return _c('li', [_vm._v(_vm._s(skill))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.cvData.certificationsSkills.soft), function(skill) {
    return _c('li', [_vm._v(_vm._s(skill))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "interests-hobbies cv-section"
  }, [_c('h2', [_vm._v("Interests & Hobbies")]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.cvData.interestsHobbies), function(interest) {
    return _c('li', [_vm._v(_vm._s(interest))])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Curriculum Vitae")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container type"
  }, [_c('strong', [_vm._v("Programming skills")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container type"
  }, [_c('strong', [_vm._v("Tooling skills")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container type"
  }, [_c('strong', [_vm._v("Soft skills")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3871b8d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cv.vue
// module id = 384
// module chunks = 1